export enum LanguageEnum {
  FR = "fr-FR",
  EN = "en-US",
}
